import ScrollPage, { SectionItem } from "../../../Components/ScrollPage/ScrollPage";
import Section from "../../../Components/Section/Section";
import DieselGenerator from "../../../Content/EngineExamples/DieselGenerator";
import WankelStory from "../../../Content/WenkleStory/WankleStory";


interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Diesel Generator Engines",        id: "dieselGenoratorEngines" }
];


const DieselGenoratorPage: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <DieselGenerator />
    </Section>
  </ScrollPage>
);

export default DieselGenoratorPage;